import React from 'react';
import { 
  Box, 
  CircularProgress, 
  Typography, 
  Fade 
} from '@mui/material';
import logo from '../assets/soyl-logo.png';

const LoadingScreen = ({ 
  logoSrc = logo, 
  loadingText = "Loading...",
  show = true 
}) => {
  return (
    <Fade in={show} timeout={300}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'background.default',
          zIndex: 9999,
        }}
      >
        {/* Logo */}
        <Box
          component="img"
          src={logoSrc}
          alt="Logo"
          sx={{
            width: { xs: 120, sm: 150, md: 180 },
            height: 'auto',
            mb: 4,
            animation: 'pulse 2s ease-in-out infinite',
            '@keyframes pulse': {
              '0%': {
                opacity: 0.7,
                transform: 'scale(1)',
              },
              '50%': {
                opacity: 1,
                transform: 'scale(1.05)',
              },
              '100%': {
                opacity: 0.7,
                transform: 'scale(1)',
              },
            },
          }}
        />

        {/* Loading Spinner */}
        {/* <CircularProgress
          size={60}
          thickness={4}
          sx={{
            mb: 3,
            color: 'primary.main',
          }}
        /> */}

        {/* Loading Text */}
        {/* <Typography
          variant="h6"
          component="div"
          sx={{
            color: 'text.secondary',
            fontWeight: 300,
            letterSpacing: 0.5,
            animation: 'fadeInOut 1.5s ease-in-out infinite',
            '@keyframes fadeInOut': {
              '0%': { opacity: 0.5 },
              '50%': { opacity: 1 },
              '100%': { opacity: 0.5 },
            },
          }}
        >
          {loadingText}
        </Typography> */}

        {/* Optional progress dots */}
        <Box
          sx={{
            display: 'flex',
            gap: 0.5,
            mt: 2,
          }}
        >
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: 'primary.main',
                animation: `dot-bounce 1.4s ease-in-out infinite both`,
                animationDelay: `${index * 0.16}s`,
                '@keyframes dot-bounce': {
                  '0%, 80%, 100%': {
                    transform: 'scale(0)',
                    opacity: 0.5,
                  },
                  '40%': {
                    transform: 'scale(1)',
                    opacity: 1,
                  },
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Fade>
  );
};

export default LoadingScreen;